{
  "name": "app-nitro-management",
  "version": "1.8.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "watch": "ng build --watch --configuration development",
    "test": "ng test --watch=false",
    "qa": "ng build --configuration qa",
    "prod": "ng build --configuration prod",
    "test:watch": "ng test --watch=true",
    "test:cov": "ng test --watch=false --coverage",
    "test:typecheck": "tsc --project tsconfig.spec.json --noEmit"
  },
  "private": true,
  "packageManager": "pnpm@10.26.0",
  "engines": {
    "node": ">=24.22.1"
  },
  "dependencies": {
    "@angular/animations": "^19.0.6",
    "@angular/cdk": "^19.0.5",
    "@angular/common": "^19.0.6",
    "@angular/compiler": "^19.0.6",
    "@angular/core": "^19.0.6",
    "@angular/forms": "^19.0.6",
    "@angular/material": "^19.0.5",
    "@angular/material-moment-adapter": "^19.0.5",
    "@angular/platform-browser": "^19.0.6",
    "@angular/platform-browser-dynamic": "^19.0.6",
    "@angular/router": "^19.0.6",
    "@azure/msal-angular": "^4.0.5",
    "@azure/msal-browser": "^4.5.0",
    "@azure/storage-blob": "^12.9.0",
    "@iplab/ngx-file-upload": "19.0.3",
    "@ngbracket/ngx-layout": "19.0.0",
    "@types/file-saver": "^2.0.5",
    "lodash-es": "~4.17.15",
    "moment": "^2.29.3",
    "normalize.css": "^8.0.1",
    "rxjs": "~7.8.1",
    "screenfull": "^6.0.1",
    "simplebar": "^5.3.6",
    "tslib": "^2.3.0",
    "uuid": "^8.3.2",
    "xlsx": "^0.18.5",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@analogjs/vite-plugin-angular": "2.8.1",
    "@analogjs/vitest-angular": "2.8.1",
    "@angular-devkit/build-angular": "^19.0.7",
    "@angular/cli": "^19.0.7",
    "@angular/compiler-cli": "^19.0.6",
    "@babel/traverse": "^7.23.3",
    "@types/lodash-es": "^4.17.6",
    "@types/node": "24.x",
    "@types/uuid": "^8.3.4",
    "@vitest/coverage-v8": "4.0.4",
    "exceljs": "^4.4.0",
    "file-saver": "^2.0.5",
    "jsdom": "26.1.0",
    "semver": "^7.5.4",
    "typescript": "~5.6.3",
    "vite": "6.4.4",
    "vite-tsconfig-paths": "5.1.4",
    "vitest": "4.0.4"
  }
}
